import { useState } from 'react';

interface FAQItem {
  q: string;
  a: string;
}

const faqs: FAQItem[] = [
  {
    q: 'Что такое YOYBUY Spreadsheet?',
    a: 'YOYBUY Spreadsheet — это автоматизированная система закупок из Китая через удобную таблицу. Вы вносите ссылки на товары с Taobao, 1688 или Weidian в spreadsheet, а мы обрабатываем заказ, выкупаем товар и доставляем его в Россию и страны СНГ. Прозрачные цены, никаких скрытых комиссий — вы всегда видите полную стоимость каждого товара.',
  },
  {
    q: 'Чем YOYBUY Spreadsheet отличается от Kakobuy?',
    a: 'Kakobuy использует веб-панель для управления заказами, в то время как YOYBUY Spreadsheet предлагает Excel-подобный интерфейс таблицы, что делает процесс закупок более наглядным и удобным. Кроме того, YOYBUY предоставляет более низкие комиссии и полную прозрачность на каждом этапе — от выкупа до доставки.',
  },
  {
    q: 'Superbuy Spreadsheet — что это?',
    a: 'Superbuy — популярный китайский агент, который также предлагает частичную поддержку таблиц. Однако YOYBUY Spreadsheet изначально построен вокруг spreadsheet-системы, что даёт более глубокую интеграцию: вы можете управлять десятками позиций одновременно, отслеживать статусы в реальном времени и получать уведомления прямо в таблице.',
  },
  {
    q: 'Безопасно ли использовать YOYBUY Spreadsheet?',
    a: 'Абсолютно безопасно. YOYBUY Spreadsheet использует защищённые платёжные шлюзы, все ваши данные шифруются. Мы не храним платёжную информацию и никогда не передаём её третьим лицам. За 100,000+ выполненных заказов мы заслужили доверие тысяч клиентов по всей России и СНГ.',
  },
  {
    q: 'Как начать покупать через YOYBUY Spreadsheet?',
    a: 'Очень просто! Нажмите кнопку "Начать с YOYBUY Spreadsheet" или "buy it now" на этой странице, и вы попадёте на нашу основную платформу. Там вы сможете зарегистрироваться, получить доступ к таблице и сразу начать добавлять товары. Никакого опыта не требуется — интерфейс интуитивно понятен.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full bg-background-100/50 py-16 md:py-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
              <i className="ri-question-line text-accent-600"></i>
            </div>
            <span className="text-sm font-medium text-accent-600 uppercase tracking-wide">FAQ</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Частые вопросы
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="font-semibold text-foreground-900 text-base pr-4">
                  {faq.q}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-200 ${
                  openIndex === i ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-600'
                }`}>
                  <i className={`text-lg transition-transform duration-300 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-6 px-6' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-base leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-foreground-600 text-sm">
            Остались вопросы?{' '}
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 font-medium hover:text-primary-700 transition-colors">
              Напишите нам →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}